import { useBienContext } from '../BienContext'

import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import { Input, Textarea } from '@/components/ui'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'energie'
  const SECTION_TITLE = 'Raccordement & Services'

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier la section Energie"
  />

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="PRM Linky" value={bien.prm_linky} valueClassName="uppercase" />
        <Input.Display label="N° compteur d'eau" value={bien.numero_compteur_eau} valueClassName="uppercase" />
        <Input.Display label="N° compteur gaz" value={bien.numero_compteur_gaz} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <Input.Display label="Localisation Linky" value={bien.loc_linky_commun} valueClassName="uppercase" />
        <Input.Display label="Localisation compteur d'eau" value={bien.loc_compteur_eau} valueClassName="uppercase" />
        <Input.Display label="Localisation compteur gaz" value={bien.loc_compteur_gaz} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <Input.Display label="N° Bac Poubelle" value={bien.numero_bac_poubelle} valueClassName="uppercase" />
        <Input.Display label="N° Badge Poubelle" value={bien.numero_badge_poubelle} valueClassName="uppercase" />
        <Input.Display label="N° Boîtier Fibre" value={bien.numero_boitier_fibre} valueClassName="uppercase" />
        { bien.type_bien === 'immeuble' && (
            <Textarea.Display label='Détail des compteurs' value={bien.detail_compteurs} className="flex flex-col items-start"/>
        )}
      </div>
    </DetailTemplate>
  )
}